import { UnsavedChangesDialog } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type QuitConfirmDialogProps = {
    open: boolean;
    isNew: boolean;
    isCreateIdentityUnknown?: boolean;
    confirmDisabled?: boolean;
    onSave: () => void;
    onConfirm: () => void;
    onCancel: () => void;
};

export const QuitConfirmDialog = (props: QuitConfirmDialogProps) => {
    const {
        open,
        isNew,
        isCreateIdentityUnknown = false,
        confirmDisabled = false,
        onSave,
        onConfirm,
        onCancel,
    } = props;
    const { t } = useTranslation();

    return (
        <UnsavedChangesDialog
            open={open}
            title={
                isNew ?
                    t("product.form.quit_dialog.creation_confirm", "Do you really wish to exit product creation?")
                :   t(
                        "product.form.quit_dialog.modification_confirm",
                        "Do you really wish to exit product modification?",
                    )
            }
            description={t(
                "product.v2.quit_confirm.unsaved_changes",
                "You have unsaved changes. What would you like to do?",
            )}
            saveLabel={t("product.v2.quit_confirm.save_and_leave", "Save and leave")}
            discardLabel={t("product.v2.quit_confirm.leave_without_saving", "Leave without saving")}
            keepEditingLabel={t("product.v2.quit_confirm.keep_editing", "Keep editing")}
            busy={confirmDisabled}
            saveDisabled={isCreateIdentityUnknown}
            onSave={onSave}
            onDiscard={onConfirm}
            onKeepEditing={onCancel}
        />
    );
};
